module.exports = __webpack_public_path__ + "img/map.48c30c98.webp";